/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { forwardRef } from 'react';
import { HiOutlineExclamation } from 'react-icons/hi';
import { IoCloseCircleOutline } from 'react-icons/io5';
import {
  Text,
  Flex,
  Tr,
  Tbody,
  Th,
  TableContainer,
  Td,
  Table,
  Thead,
  Center,
  Icon,
  Box,
} from '@chakra-ui/react';
import { TableSkele } from 'components/Skeletons/DataTable';
import { generateId } from 'utils/functions';
import { tableLabels } from './mocks';

interface CustomTableProps {
  data: any;
  labels?: any;
  loading?: boolean;
  error?: boolean;
}

const CustomTable = forwardRef<HTMLDivElement | null, CustomTableProps>(
  ({ data, labels = tableLabels, loading, error }) => {
    return (
      <Box
        my="24px"
        py="0px"
        px="0px"
        minH="0px"
        borderRadius="16px"
        justifyContent="start"
        w="100%"
      >
        {!error && data ? (
          <>
            {loading ? (
              <Flex
                position="relative"
                justify="center"
                align="center"
                w="100%"
              >
                <TableSkele labels={labels} />
              </Flex>
            ) : (
              <TableContainer border="0.5px solid #D9D9D9">
                <Table>
                  <Thead bg="grey.400">
                    <Tr>
                      {labels?.map((item: any) => (
                        <Th
                          key={item.title}
                          fontSize="12px"
                          fontWeight={400}
                          textTransform="none"
                          textColor="text.100"
                        >
                          {item.name}
                        </Th>
                      ))}
                    </Tr>
                  </Thead>
                  <Tbody>
                    {data?.map((item: any, index: number) => (
                      <Tr key={index}>
                        {Object.keys(item).map(key => (
                          <Td
                            overflow="hidden"
                            key={item[key] + generateId()}
                            py="8px"
                            borderColor="#D9D9D9"
                            fontWeight={400}
                            textTransform="none"
                            textColor="text.100"
                            fontSize="12px"
                          >
                            {key === 'error' ? (
                              <Flex gap="6px" alignItems="center">
                                <Icon
                                  w="20px"
                                  h="20px"
                                  color="red"
                                  as={IoCloseCircleOutline}
                                />
                                {item[key]}
                              </Flex>
                            ) : (
                              <Text maxW="160px" isTruncated color="text.100">
                                {item[key]}
                              </Text>
                            )}
                          </Td>
                        ))}
                      </Tr>
                    ))}
                  </Tbody>
                </Table>
              </TableContainer>
            )}
          </>
        ) : (
          <Center my="26px" flexDirection="column">
            <Icon
              borderRadius="100px"
              padding="16px"
              bg="grey.200"
              w="80px"
              h="80px"
              as={HiOutlineExclamation}
              color="grey.600"
            />
            <Text mt="8px" fontWeight="medium" color="black" fontSize="18px">
              Relatório de erros
            </Text>
            <Text mt="4px" color="text.200" fontSize="12px">
              Ocorreu um erro ao validar sua planilha
            </Text>
          </Center>
        )}
      </Box>
    );
  },
);

CustomTable.displayName = 'CustomTable';

export { CustomTable };
